import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IBankDetails, prettyPrintIBAN } from '@mwe/models';

@Component({
  selector: 'mwe-bank-details',
  templateUrl: './bank-details.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankDetailsComponent {
  bankDetails = input<IBankDetails>();

  private ibanPretty = computed(() => prettyPrintIBAN(this.bankDetails()?.iban ?? ''));

  private bankName = computed(() => this.bankDetails()?.bankdaten?.bankname ?? '');

  bankImgAlt = computed(() => `${this.bankName()} ${this.ibanPretty()}`.trim());

  bankDataText = computed(() => {
    const name = this.bankName();
    const bankNameHtml = name ? `${name}<br>` : '';
    return bankNameHtml + this.ibanPretty();
  });
}
